<form [formGroup]="form" autocomplete="off" class="form-horizontal">
  <div id="allgemeineAngaben">

    <div class="form-row">
      <label class="d-none d-sm-inline col-sm-3 col-form-label" for="beginnDerTaetigkeit">
          <span class="d-flex justify-content-between">
            <span>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.BEGINN' | translate }}</span>
          </span>
      </label>
      <div class="d-none d-sm-flex col-sm-1 small-stammdaten-button">
        <common-ui-daten-uebernahme (picked)="form.get('beginnDerTaetigkeit').setValue($event)"
                                    [itemTemplate]="stammdatenTemplate"
                                    [items]="beginnDerTaetigkeitStammdaten"
                                    [readonly]="readonly"
                                    context="beginnDerTaetigkeit"
                                    imageOnly="true"></common-ui-daten-uebernahme>
      </div>
      <div class="col-sm-8">
        <date-picker
                id="beginnDerTaetigkeit"
                messagePath="beginnDerTaetigkeit"
                formControlName="beginnDerTaetigkeit"
                [isRequired]=true>
        </date-picker>
      </div>
    </div>

    <div *ngIf="isKapGAus" class="form-check">
      <input class="form-check-input" formControlName="offenTaetigkeit"
             id="offenTaetigkeit"
             type="checkbox">
      <label class="form-check-label"
             for="offenTaetigkeit">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.DAUERTAETIGKEITOFFEN' | translate }}
      </label>
    </div>

    <div *ngIf="isKapGAus && data.offenTaetigkeit" class="form-row mt-2x">
      <label class="d-none d-sm-inline col-sm-4 col-form-label" for="endDerTaetigkeit">
          <span class="d-flex justify-content-between">
            <span>{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.END' | translate }}</span>
          </span>
      </label>

      <div class="col-sm-8">
        <date-picker
                id="endDerTaetigkeit"
                messagePath="endDerTaetigkeit"
                formControlName="endDerTaetigkeit"
                [isRequired]=true>
        </date-picker>
      </div>
    </div>

    <ng-template #stammdatenTemplate let-item="item">
      <h4
        class="list-group-item-heading">{{ 'COMMON_UI.FRAGEBOGEN.BEGINN_TAETIGKEIT_WJ_STAMMKAPITAL_ANGABEN.BEGINN' | translate }}</h4>
      <p class="list-group-item-text">{{item}}</p>
    </ng-template>
  </div>
</form>

